<template>
  <div>
    <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
      <div id="myCal">
        <!-- 保费试算 -->
        <div class="title_">
          <div class="cutleft_ order">保费试算</div>
          <div class="cutleft_ policy">险种信息</div>
          <div class="cutoff_"></div>
        </div>
        <a-row class="changeStyle_">
          <a-col :span="19">
            <div style="width: 100%;">
              <div class="form_item policy_none">
                <label>保障期间</label>
                <div class="pre-box">
                  <a-radio-group
                    v-model="guapre"
                    :disabled="disabledAll"
                    @change="e => changeData(e.target.value, 'BZQJa')"
                  >
                    <a-radio
                      v-for="item in guarantPre"
                      :key="item.key"
                      :value="item.key"
                    >{{ item.value }}</a-radio>
                  </a-radio-group>
                </div>
              </div>
              <div class="form_item">
                <label>投保人数</label>
                <div class="right_">
                  <div
                    class="check_item s_input"
                    v-for="item in occupationNumberList"
                    :key="item.occupationKind"
                  >
                    <label for>{{ item.occupationKind }}</label>
                    <a-input-number
                      :disabled="disabledAll"
                      :min="0"
                      v-model="item.personNum"
                      @change="value => changeData(value, 'TBZYa')"
                    ></a-input-number>
                    <span>人</span>
                  </div>
                </div>
              </div>
              <div class="policy_none">
                <a @click="$tools.downloadFile(fileCodeContent.occ_url)">职业类别表</a>
              </div>
            </div>
          </a-col>
          <a-col :span="4" class="calRight_ policy_none">
            <div class="calTxt_">保费合计</div>
            <div class="calmoney_">¥ {{ premiumSum }}</div>
          </a-col>
        </a-row>
      </div>
      <div class="risk_">
        <p class="p-header">主险</p>
        <!-- 意外身故及伤残 -->
        <div class="form_item">
          <label>意外伤害</label>
          <div class="right_">
            <a-select
              placeholder="请选择"
              style="width: 300px"
              :disabled="disabledAll"
              class="select_"
              @change="value => changeData(value, 'SWCJ')"
              v-model="countData.SWCJ"
            >
              <a-select-option
                v-for="item in swcjOptions"
                :key="item.value + 'SWCJ'"
                :value="item.value"
              >{{ item.name }}</a-select-option>
            </a-select>
          </div>
        </div>
        <p class="p-header">附加险</p>
        <div class="flex_">
          <!-- 意外伤害医疗 -->
          <div class="form_item">
            <label>意外伤害医疗</label>
            <div class="right_">
              <a-select
                :disabled="disabledAll"
                placeholder="请选择"
                style="width: 300px"
                class="select_"
                v-model="countData.YLFY"
                @change="value => changeData(value, 'YLFY')"
              >
                <a-select-option
                  v-for="(item, index) in ylfyOptions"
                  :key="item.value + 'YLFY' + index"
                  :value="item.value"
                >{{ item.name }}</a-select-option>
              </a-select>
            </div>
          </div>
           <!--意外伤害住院津贴 -->
          <div class="form_item">
            <label>意外伤害住院津贴</label>
            <div class="right_">
              <a-select
                placeholder="请选择"
                style="width: 300px"
                class="select_"
                :disabled="disabledAll"
                v-model="countData.KZSC"
                @change="value => changeData(value, 'KZSC')"
              >
                <a-select-option
                  v-for="item in KZSCOptions"
                  :key="item.value + 'KZSC'"
                  :value="item.value"
                >{{ item.name }}</a-select-option>
              </a-select>
            </div>
          </div>
          <!-- 按工伤致残鉴定标准 -->
          <div class="form_item">
            <label>按工伤致残鉴定标准</label>
            <div class="right_">
              <a-select
                placeholder="请选择"
                style="width: 300px"
                :disabled="disabledAll"
                class="select_"
                v-model="countData.SHHLa"
                @change="value => changeData(value, 'SHHLa')"
              >
                <a-select-option
                  v-for="item in SHHLOptions"
                  :key="item.value + 'SHHLa'"
                  :value="item.value"
                >{{ item.name }}</a-select-option>
              </a-select>
            </div>
          </div>
        </div>
        <div class="btn_list nfl">
          <a-button
            class="calBtn_"
            type="primary"
            @click="countPremiumSum"
            :disabled="disabledAll"
          >刷新试算</a-button>
          <a-button
            style="margin-bottom: 50px"
            class="calBtn_"
            type="primary"
            v-if="!agreementRead"
            @click="goplicy"
            :disabled="disabledAll"
          >去投保</a-button>
        </div>
      </div>
    </a-form>
  </div>
</template>

<script>
let DATA = require('../data').default;
import { riskinfoMixin } from '@/mixins/riskinfoMixin.js';
export default {
  data() {
    return {
      category: '1', //手选职业类别
      guapre: '1',
      form: this.$form.createForm(this, { name: 'advanced_search' }),
      //投保职业及人数
      occupationNumberList: DATA.occupationNumberList,
      premiumSum: 0, //总保费
      HYLXArr: [], //行业类型
      guarantPre: DATA.guarantPre,
      SHHLOptions: DATA.SHHLOptions,
      // 测算要提交的数据
      countData: {
        BZQJa: 12, //保障期间?
        stature: 2, //是否涉高
        TBZYa: 0, //投保职业?
        HYLX: '', //行业类型
        SWCJ: 100000, //意外身故及伤残 1
        YLFY: 0, //意外医疗费用 2
        JTKJ: 0, //意外医疗费用免赔额 3
        ZYJT: 100, //意外医疗费用赔付比例 4
        KZSC: 0, //意外每日住院津贴 5
        YCXSCa: 0, //民航客运飞机意外身故及伤残 6
        SHHLa: 0, //火车意外身故及伤残 7
        YLFYBC: 0, //轮船意外身故及伤残 8
        KYQCYW: 0 //公共汽车意外身故及伤残 9
      },
      //提交data
      data: {
        riskInfos: [
          {
            riskCode: '0754001', //意外伤害
            dutyCode: 'E920',
            amount: 100000,
            premiumAmt: 0,
            riskName: '意外伤害',
            riskAmountDesc: 100000
          }
        ],
        salPolicy: {
          productCode: '', //产品code
          planCode: '', //plancode
          optionalFlag: 1 //保费期限
        },
        salPolicyExt: {
          isworkheightinvolved: 2
        },
        salPolicyHolder: {
          addfifty: '2', // 测算类型
          industrycode: '', //行业code
          stature: 2 //是否高空（2-否，1-是）
        },
        premiumBaseDtoList: [] //人数
      },
      creator: '1',
      productCode: '',
      plan: ''
    };
  },
  mixins: [riskinfoMixin],
  computed: {
    ylfybcBCOptions() {
      let ylfybcBCOptions = DATA.ylfybcBCOptions;
      return ylfybcBCOptions;
    },
    // 意外每日住院津贴
    KZSCOptions() {
      let KZSCOptions = [
        {
          value: 0,
          name: '不附加'
        },
        {
          value: 50,
          name: '50元/天'
        },
        {
          value: 100,
          name: '100元/天'
        },
        {
          value: 150,
          name: '150元/天'
        }
      ];
      return KZSCOptions;
    },
    // 意外身故及伤残
    swcjOptions() {
      let Options = DATA.swcjOptions;
      return Options;
    },
    // 意外医疗费用
    ylfyOptions() {
      let option = DATA.ylfyOptions;
      option = option.filter(item => item.value <= this.countData.SWCJ * 0.2);
      return option
    },
    // 计算总投保人数
    totalNumber() {
      let num = 0;
      this.occupationNumberList.forEach(e => {
        num += Number(e.personNum);
      });
      return parseInt(num);
    },
    // 险种的数组
    riskInfos() {
      let infos = [
        {
          riskCode: '0754001', //意外伤害
          dutyCode: 'E920',
          amount: this.countData.SWCJ,
          premiumAmt: 0,
          riskName: '意外伤害',
          riskAmountDesc: this.countData.SWCJ
        },
        {
          riskCode: '0754002', //意外伤害医疗
          dutyCode: 'E921',
          amount: this.countData.YLFY,
          premiumAmt: 0,
          riskName: '意外伤害医疗',
          riskAmountDesc: this.countData.YLFY
        },
        {
          riskCode: '0754003', //意外伤害住院津贴
          dutyCode: 'E922',
          amount: this.countData.KZSC,
          premiumAmt: 0,
          riskName: '意外伤害住院津贴',
          riskAmountDesc: this.countData.KZSC
        },
        {
          riskCode: 'TY10', //按工伤致残鉴定标准
          dutyCode: 'TY10',
          amount: this.countData.SHHLa,
          premiumAmt: 0,
          riskName: '按工伤致残鉴定标准',
          riskAmountDesc: this.countData.SHHLa
        }
      ];
      return infos;
    }
  },
  watch: {
    'countData.YLFY'(val) {
      //初始化选项
      if (!val) {
        this.countData.JTKJ = 0;
      }
    }
  },
  mounted() {
    this.$bus.$on('busRiskInfos', data => {
      //返显险种信息
      data.riskInfos.forEach(e => {
        if (e.riskCode == '0754001') this.countData.SWCJ = e.amount;
        if (e.riskCode == '0754002') this.countData.YLFY = e.amount;
        if (e.riskCode == '0754003') this.countData.KZSC = e.amount;
        if (e.riskCode == 'TY10') this.countData.SHHLa = e.amount;
      });
    });
    this.$bus.$on('busStature', data => {
      //返现涉高信息
      this.countData.stature = data - 0;
    });
  },
  methods: {
    clearNumberList() {
      //投保职业及人数
      this.occupationNumberList = DATA.occupationNumberList;
    },
    // 改变试算的数据
    changeData() {
      this.data = {
        riskInfos: this.riskInfos.filter(item => item.amount > 0), //险种信息
        salPolicy: {
          planCode: this.plan,
          creator: this.creator,
          productCode: this.productCode, //产品code
          optionalFlag: this.guapre, //保费期限
          discountfactor: 1 //折扣系数
        },
        salPolicyHolder: {
          addfifty: '1', // 测算类型
          stature: this.countData.stature //是否高空（2-否，1-是）
        },
        salPolicyExt: {
          isworkheightinvolved: this.countData.stature //是否高空作业
        },
        premiumBaseDtoList: [...this.$lodash.cloneDeep(this.occupationNumberList).filter(item => item.personNum > 0)] //人数
      };
      let arrData = this.$lodash.cloneDeep(this.data);
      this.$bus.$emit('onRiskInfos', arrData);
    },
    //保费试算
    countPremiumSum(e) {
      e.preventDefault();
      let formData = this.$lodash.cloneDeep(this.data);
      this.form.validateFields(err => {
        //保费试算接口
        if (!err) {
          if (this.totalNumber < 3) {
            this.premiumSum = 0;
            this.$message.warning('最低投保人数3人');
            return;
          }
          this.$api.calPremiumEmployer(formData).then(res => {
            if (res.data.success) {
              let data = res.data.content;
              this.premiumSum = data.totalPremium; //放入保费
            } else {
              this.$message.error(res.data.returnMsg + '错误');
            }
          });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.policy {
  display: none;
}

.calTxt_ {
  font-size: 18px !important;
  font-weight: bold !important;
  color: #666666;
}

.pre-box {
  margin-top: 15px;
}

.form_items {
  display: flex;
  width: 100%;
  color: #333;
  margin-bottom: 10px;
}

.risk_ {
  width: 60%;
}

.btn_list {
  margin-top: 20px;
  display: flex;

  .calBtn_ {
    margin-right: 30px;
  }
}

.flex_ {
  display: flex;
  flex-wrap: wrap;
}

.form_item {
  display: flex;
  justify-content: space-between;
  width: 100%;
  color: #333;
  margin-bottom: 10px;

  &.width_50 {
    width: 50%;
  }

  &.width_40 {
    width: 40%;
  }

  &.width_60 {
    width: 60%;
  }

  > label {
    white-space: nowrap;
    margin-right: 10px;
    margin-top: 15px;
  }

  .right_ {
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;

    .select_ {
      margin-top: 10px;
    }

    .check_item {
      display: flex;
      align-items: center;
      margin-right: 10px;
      margin-top: 10px;

      &.on {
        label {
          border-color: #fe8f2d;
        }
      }

      label {
        // border: 1px solid #d9d9d9;
        padding: 3px 10px;
        border-radius: 3px;
        margin-right: 5px;
      }

      &.s_input input {
        width: 50px;
      }

      input {
        width: 150px;
        margin-right: 5px;
      }
    }
  }
}

.p-header {
  width: 100%;
  font-weight: bold;
  font-size: 15px;
  margin-bottom: 0;
}
</style>